import {
  callAPI,
  setPolicy,
  fetchActionConfig,
  fetchQueriesAndFragments,
  fetchRoleAuthorization,
  fetchUISchema,
  fetchValidation,
  setData,
  setStoreState,
  loadMastersByContainer,
} from '@cogitate/ui-multi-utils';
import { currentLineLob } from './helper';

import {
  axiosKeys,
  buttonRouteKeys,
  PolicyLogHeader,
  policySchemaKeys,
  routeKeys,
  storeKeys,
} from 'ui/data/constants/keys';
import { getMasterCallHeaders } from 'ui/utilities/getMasterCallHeaders';
import { getInitialState } from 'ui/components/initialData';
import {
  hydratePolicyUserRole,
  loadRoleScopedUserMasters,
} from 'ui/utilities/agencyAgentUwMasters';

/**
 * Fetches master data from blob and DB, sets initial application data and user role.
 * Agency/Agent/UW catalogs are role-scoped and slim (Code/Name) in MasterReducer;
 * full records are hydrated onto the policy via hydratePolicyUserRole.
 * @returns {Promise<void>}
 */
export const getMasterFromBlobAndDB = async () => {
  try {
    // Get LOB data from Masters
    const url = `${process.env.NEXT_PUBLIC_MASTER_DATA_URL}master?client=${process.env.NEXT_PUBLIC_CLIENT}&table=SelectedLineLob`;
    const resp = await callAPI(
      axiosKeys.GetAction,
      url,
      null,
      getMasterCallHeaders()
    );
    if (resp[0]) {
      setStoreState(storeKeys.ApplicationReducer, {
        selectedBusinessLine: resp[0], // Since single lob directly mapping it.
      });
    } else {
      throw new Error('LOB Data Not Found!');
    }

    const lineLob = currentLineLob();
    const { masterReducer } = require(
      `ui/data/${lineLob}/constants/masterReducer.js`
    );
    const { staticItems } = require(`ui/data/${lineLob}/constants/static.js`);

    if (masterReducer) {
      setStoreState(storeKeys.MasterReducer, masterReducer);
    }

    // Fetch Master Data -- Start
    await setData({
      buttonRouteKeys,
      routeKeys,
      staticItems,
      PolicyLogHeader,
      policySchemaKeys,
    });
    await fetchQueriesAndFragments();
    await Promise.all([
      loadMastersByContainer(),
      fetchRoleAuthorization(),
      fetchValidation(),
      fetchActionConfig(),
      fetchUISchema(),
    ]).catch((error) => {
      console.error('Utilities.Helpers.fetchApplicationData ', error);
      throw error;
    });
    await loadRoleScopedUserMasters();
    // Fetch Master Data -- End

    // Set Initial Data and Current User Role (full Agency/Agent/UW on policy)
    await setPolicy(getInitialState());
    await hydratePolicyUserRole();
  } catch (error) {
    console.error('Utilities.Helpers.fetchApplicationData ', error);
    throw error;
  }
};
